export default __webpack_public_path__ + "static/media/bonuses-left-bg.07b761e4.png";